import { ADYEN_ENVIRONMENT_LIVE, BILLING_ADDRESS_MODE_PARTIAL, PAGE_TEXT } from "./paymentPage.constants";

const MONEY_LOCALE = "en-GB";
const MONEY_STYLE = "currency";
const DECIMAL_BASE = 10;

export const NO_ORDER_SUMMARY = Object.freeze({ isAvailable: false });

function isLiveEnvironment(environment) {
    return environment === ADYEN_ENVIRONMENT_LIVE;
}

function isConfiguredKey(clientKey) {
    return typeof clientKey === "string";
}

export function resolveClientKey(environment) {
    if (isLiveEnvironment(environment)) {
        return process.env.REACT_APP_ADYEN_CLIENT_KEY;
    }
    if (isConfiguredKey(process.env.REACT_APP_ADYEN_CLIENT_KEY_TEST)) {
        return process.env.REACT_APP_ADYEN_CLIENT_KEY_TEST;
    }
    return process.env.REACT_APP_ADYEN_CLIENT_KEY;
}

export function formatMinorUnitsAsMoney(amountInMinorUnits, currencyCode) {
    const formatter = new Intl.NumberFormat(MONEY_LOCALE, { style: MONEY_STYLE, currency: currencyCode });
    const decimalPlaces = formatter.resolvedOptions().maximumFractionDigits;
    return formatter.format(amountInMinorUnits / Math.pow(DECIMAL_BASE, decimalPlaces));
}

export function buildOrderSummary(paymentLinkPage) {
    if (paymentLinkPage.isCardSaving) {
        return NO_ORDER_SUMMARY;
    }
    return Object.freeze({
        isAvailable: true,
        vendor: paymentLinkPage.vendor,
        description: paymentLinkPage.description,
        amount: formatMinorUnitsAsMoney(paymentLinkPage.amount.value, paymentLinkPage.amount.currency),
        reference: PAGE_TEXT.REFERENCE_PREFIX + paymentLinkPage.reference,
    });
}

export function buildCheckoutConfiguration(paymentLinkPage, checkoutSession, dropinCallbacks) {
    return {
        environment: paymentLinkPage.environment,
        clientKey: resolveClientKey(paymentLinkPage.environment),
        session: { id: checkoutSession.sessionId, sessionData: checkoutSession.sessionData },
        ...dropinCallbacks,
    };
}

function applyCardSavingConfiguration(dropinConfiguration, paymentLinkPage) {
    if (paymentLinkPage.isCardSaving) {
        return { ...dropinConfiguration, showStoredPaymentMethods: false };
    }
    return dropinConfiguration;
}

function applyBillingAddressConfiguration(dropinConfiguration, paymentLinkPage) {
    if (paymentLinkPage.isBillingAddressRequired === false) {
        return dropinConfiguration;
    }
    return {
        ...dropinConfiguration,
        paymentMethodsConfiguration: {
            card: {
                billingAddressRequired: true,
                billingAddressMode: BILLING_ADDRESS_MODE_PARTIAL,
                data: { billingAddress: paymentLinkPage.billingAddress },
            },
        },
    };
}

export function buildDropinConfiguration(paymentLinkPage) {
    const baseConfiguration = { showPayButton: true };
    const savingConfiguration = applyCardSavingConfiguration(baseConfiguration, paymentLinkPage);
    return applyBillingAddressConfiguration(savingConfiguration, paymentLinkPage);
}
